import { useTranslation } from '../../core/hooks/useTranslation'

interface CancelButtonProps {
    onClick: () => void
    className?: string
    label?: string
    disabled?: boolean
}

export default function CancelButton({
    onClick,
    className = '',
    label,
    disabled = false
}: CancelButtonProps) {
    const { t } = useTranslation()
    const displayLabel = label || t('cancel')

    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={`border border-gray-300 px-8 py-3 text-sm font-semibold text-[#1E293B] hover:text-[#1E293B] hover:border-[#1E293B] hover:bg-gray-50 active:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center rounded-xl transition-colors ${className}`}
        >
            {displayLabel}
        </button>
    )
}

